import React, { useContext, useState } from 'react';
import queryString from 'query-string';
import classNames from 'classnames';
import { PuffLoader } from 'react-spinners';
import withSpinner from '../../shared/hoc/withSpinner';
import { Page, Title, AuthContext } from '../../shared';
import { ReactComponent as BeeHeroIcon } from '../../images/BeeHeroIcon.svg';
import LoginForm from './LoginForm';
import AllApps from './components/AllApps';
import styles from '../Main.module.scss';
import MainHoc from '../MainHoc';
import PropTypes from 'prop-types';
import { choosePlatformText, titleText } from './textConsts';
import { loginToYourAccountText } from '../../shared/consts';
import useMediaQuery from '../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../shared/MediaQuery/mediaQueryUtils';

const Login = (props) => {
    const { userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery(isMobileQuery);
    const [loading, setLoading] = useState(false);
    const DISABLE_GOOGLE_LOGIN = 'disable_google_login';

    let appRedirection = '';
    let queryParams = '';
    const currentUrl = window.location.href;
    if (currentUrl.includes('commandRoom')) {
        appRedirection = currentUrl.substring(currentUrl.indexOf('commandRoom'));
    } else {
        const parsed = queryString.parse(props.location.search);
        appRedirection = parsed.to;
        queryParams = props.location.search.replace(`to=${appRedirection}`, '');
    }

    const isGoogleLoginDisabled = currentUrl.includes(DISABLE_GOOGLE_LOGIN);

    if (currentUrl?.includes('hello.beehero.io')) {
        window.location.href = 'https://accounts.beehero.io/contact_us';
        return (
            <div
                className={classNames(styles.backdrop, {
                    [styles.full_width]: isMobile
                })}
            >
                <PuffLoader color={'#ffcc2e'} size={100} />
            </div>
        );
    }

    return (
        <MainHoc>
            <div className={classNames({ [styles.content]: !isMobile })}>
                {loading && (
                    <div
                        className={classNames(styles.backdrop, {
                            [styles.full_width]: isMobile
                        })}
                    >
                        <PuffLoader color={'#ffcc2e'} size={100} />
                    </div>
                )}

                <Page>
                    <Page.Section>
                        <Title
                            small
                            subtitleMargin
                            flex
                            title={titleText}
                            svg={BeeHeroIcon}
                            subtitle={userInfo ? choosePlatformText : loginToYourAccountText}
                            iconSize={40}
                        />
                        {userInfo ? (
                            <AllApps userRoles={userInfo?.rolenames} />
                        ) : (
                            <LoginForm
                                appRedirection={appRedirection}
                                setLoading={setLoading}
                                queryParams={queryParams}
                                displayGoogleSignIn={!isGoogleLoginDisabled}
                            />
                        )}
                    </Page.Section>
                </Page>
            </div>
        </MainHoc>
    );
};

Login.propTypes = {
    location: PropTypes.object
};

export default withSpinner(Login);
